(function() {
  'use strict';

  angular
    .module('zelincek', ['ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria', 'ui.router', 'toastr', 'uiGmapgoogle-maps', 'jkuri.gallery', 'noCAPTCHA']);

})();

(function() {
  'use strict';

  angular
      .module('zelincek')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Stylus',
        'url': 'http://learnboost.github.io/stylus/',
        'description': 'Stylus is a revolutionary new language, providing an efficient, dynamic, and expressive way to generate CSS. Supporting both an indented syntax and regular CSS style.',
        'logo': 'stylus.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('zelincek')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('zelincek')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
  'use strict';

  angular
    .module('zelincek')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('zelincek')
    .controller('CleaningServicesController', CleaningServicesController);

  /** @ngInject */
  function CleaningServicesController($scope, $stateParams) {
    var vm = this;
    $scope.currentPage = 'cleaning';

    $scope.currentSubpage = 'services';

    $scope.subpages = [
      {
        id: 'ciscenje-odjevnih-predmeta',
        title: 'Čišćenje odjevnih predmeta'
      },
      {
        id: 'ciscenje-opreme',
        title: 'Čišćenje opreme'
      },
      {
        id: 'bojanje-odjevnih-predmeta',
        title: 'Bojanje odjevnih predmeta'
      },
      {
        id: 'ciscenje-koznih-predmeta',
        title: 'Čišćenje kožnih predmeta'
      },
      {
        id: 'peglanje-odjece',
        title: 'Peglanje odjeće'
      },
      {
        id: 'pranje-peglanje-odjece',
        title: 'Pranje i peglanje odjeće'
      }
    ];


    if ($stateParams.serviceName) {
      $scope.currentSubpage = $stateParams.serviceName;
    }




  }
})();

(function() {
  'use strict';

  angular
    .module('zelincek')
    .controller('CleaningPricesController', CleaningPricesController);

  /** @ngInject */
  function CleaningPricesController($scope, $stateParams, $location) {
    var vm = this;
    $scope.currentPage = 'cleaning';

    $scope.currentSubpage = 'prices';

    $scope.subpages = [
      {
        id: 'ciscenje-odjevnih-predmeta',
        title: 'Čišćenje odjevnih predmeta',
        active: true
      },
      {
        id: 'ciscenje-opreme',
        title: 'Čišćenje opreme',
        active: false
      },
      {
        id: 'bojanje-odjevnih-predmeta',
        title: 'Bojanje odjevnih predmeta',
        active: false
      },
      {
        id: 'ciscenje-koznih-predmeta',
        title: 'Čišćenje kožnih predmeta',
        active: false
      },
      {
        id: 'peglanje-odjece',
        title: 'Peglanje odjeće',
        active: false
      },
      {
        id: 'pranje-peglanje-odjece',
        title: 'Pranje i peglanje odjeće',
        active: false
      }
    ];


    if ($stateParams.serviceName) {
      $scope.currentSubpage = $stateParams.serviceName;
      for (var i = 0; i < $scope.subpages.length; i++) {
        $scope.subpages[i].active = false;
        if ($scope.subpages[i].id === $scope.currentSubpage) {
          $scope.subpages[i].active = true;
        }
      }
    } else {
      $location.path('/ekoloska-kemijska-cistionica/cjenik/ciscenje-odjevnih-predmeta');
    }




  }
})();

(function() {
  'use strict';

  angular
    .module('zelincek')
    .controller('CleaningOrderController', CleaningOrderController);

  /** @ngInject */
  function CleaningOrderController($scope, MailerService) {
    var vm = this;
    $scope.currentPage = 'cleaning';

    // possible services
    $scope.services = ['kemijsko čišćenje odjeće i opreme', 'kemijsko čišćenje tepiha', 'pranje', 'peglanje'];

    // selected service
    $scope.selection = [];

    // toggle selection for a given fruit by name
    $scope.toggleSelection = function toggleSelection(item) {
      var idx = $scope.selection.indexOf(item);

      // is currently selected
      if (idx > -1) {
        $scope.selection.splice(idx, 1);
      }

      // is newly selected
      else {
        $scope.selection.push(item);
      }
    };


    $scope.gRecaptchaResponse = '';
    $scope.$watch('gRecaptchaResponse', function (){
      $scope.expired = false;
    });
    $scope.expiredCallback = function expiredCallback(){
      $scope.expired = true;
    };

    // Form model
    $scope.model = {};


    $scope.Order = function () {
      $scope.isSentSuccess = false;
      $scope.isSentError = false;
      $scope.isSentInProgress = true;

      if ($scope.selection.length < 1) {
        alert ("Barem jedna usluga mora biti izabrana!");
        return;
      }

      var message = "Poštovani, \n\n";
      message += "zahvaljujemo se na Vašoj narudžbi koja je poslana na info@zelincek.hr te ćemo Vam odgovoriti u najkraćem mogućem roku i vidimo se uskoro.\n\n";
      message += "S poštovanjem,\nZelinček j.d.o.o.";
      message += "\n\n";
      if ($scope.model.name) {
        message += "<b>Ime i prezime:</b> " + $scope.model.name + "\n";
      }
      if ($scope.model.email) {
        message += "<b>E-mail adresa:</b> " + $scope.model.email + "\n";
      }
      if ($scope.model.phone) {
        message += "<b>Tražene usluge:</b> " + $scope.selection.join(", ") + "\n";
      }
      if ($scope.model.phone) {
        message += "<b>Mobitel ili telefon:</b> " + $scope.model.phone + "\n";
      }
      if ($scope.model.address) {
        message += "<b>Ulica i broj:</b> " + $scope.model.address + "\n";
      }
      if ($scope.model.pickup) {
        message += "<b>Termin preuzimanja robe:</b> " + $scope.model.pickup + "\n";
      }
      message += "<b>Komentar:</b>\n" + $scope.model.comment;

      var data = {
        'RECAPTCHA_RESPONSE': $scope.gRecaptchaResponse,
        'NAME': $scope.model.name,
        'EMAIL': $scope.model.email,
        'SUBJECT': 'ZELINČEK.hr - online narudžba',
        'MESSAGE': message
      };

      MailerService.send(data, function (response) {
        console.error(response);
        $scope.isSentInProgress = false;
        if (response && response.data && response.data.success) {
          $scope.isSentSuccess = true;
        } else {
          $scope.isSentError = true;
        }
      }, function (response) {
        console.error(response);
        $scope.isSentInProgress = false;
        $scope.isSentError = true;
      });

    }







  }
})();

(function() {
  'use strict';

  angular
    .module('zelincek')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1447760132430;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('zelincek')
    .controller('SuitsController', SuitsController);

  /** @ngInject */
  function SuitsController($scope, $location, $anchorScroll) {
    var vm = this;
    $scope.currentPage = 'suits';

    var images = [
      {id: 1},
      {id: 2},
      {id: 3},
      {id: 4},
      {id: 5},
      {id: 6},
      {id: 7},
      {id: 8},
      {id: 9},
      {id: 10},
      {id: 11},
      {id: 12},
      {id: 13},
      {id: 14},
      {id: 15},
      {id: 16},
      {id: 17},
      {id: 18},
      {id: 19},
      {id: 20},
      // {id: 21},
      // {id: 22},
      // {id: 23},
      // {id: 24},
      // {id: 25},
      // {id: 26},
      // {id: 27},
      // {id: 28},
      // {id: 29},
      // {id: 30},
      // {id: 31},
      // {id: 32},
      // {id: 33},
      // {id: 34},
      // {id: 35},
      // {id: 36},
      // {id: 37},
      // {id: 38},
      // {id: 39},
      // {id: 40},
      // {id: 41},
      // {id: 42},
      // {id: 43},
      // {id: 44},
      // {id: 45},
      // {id: 46},
      // {id: 47},
      // {id: 48},
      // {id: 49},
      // {id: 50},
      // {id: 51},
      // {id: 52},
      // {id: 53},
      // {id: 54},
      // {id: 55},
      // {id: 56},
      // {id: 57},
      // {id: 58},
      // {id: 59},
      // {id: 60},
      // {id: 61},
      // {id: 62},
      // {id: 63},
      // {id: 64},
      // {id: 65},
      // {id: 66},
      // {id: 67},
      // {id: 68},
      // {id: 69},
      // {id: 70},
      // {id: 71},
      // {id: 72}
    ];

    vm.images = [];

    for (var i = 0; i < images.length; i++) {
      vm.images.push({
        thumb: 'assets/images/suits-gallery-thumbs/' + images[i].id + '.jpg',
        img: 'assets/images/suits-gallery/' + images[i].id + '.jpg',
        description: ''
      });
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('zelincek')
    .service('MailerService', MailerService);

  /** @ngInject */
  function MailerService($http) {
    var url = 'http://mailer.zelincek.hr';

    this.send = function (data, success, error) {
      $http.post(url, data).then(success, error);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('zelincek')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController($scope) {
    var vm = this;
    $scope.currentPage = 'home';

    $scope.isCleaningActive = false;
    $scope.isSuitsActive = false;
    $scope.isBarriersActive = false;
  }
})();

(function() {
  'use strict';

  angular
    .module('zelincek')
    .controller('ContactController', ContactController);

  /** @ngInject */
  function ContactController($scope, MailerService) {
    var vm = this;
    $scope.currentPage = 'contact';

    $scope.smallLogo = true;

    var latitude = 45.9624109;
    var longitude = 16.2457205;

    $scope.map = {
      center: {
        latitude: latitude,
        longitude: longitude
      },
      zoom: 13
    };

    $scope.marker = {
      id: 0,
      coords: {
        latitude: latitude,
        longitude: longitude
      },
      options: { draggable: true },
      events: null
    };

    $scope.gRecaptchaResponse = '';
    $scope.$watch('gRecaptchaResponse', function (){
      $scope.expired = false;
    });
    $scope.expiredCallback = function expiredCallback(){
      $scope.expired = true;
    };

    // Form model
    $scope.model = {};

    $scope.Send = function () {
      $scope.isSentSuccess = false;
      $scope.isSentError = false;
      $scope.isSentInProgress = true;

      var message = "Poštovani, \n\n";
      message += "zahvaljujemo se na Vašem upitu koji je poslan na info@zelincek.hr te ćemo Vam odgovoriti u najkraćem mogućem roku.\n\n";
      message += "S poštovanjem,\nZelinček j.d.o.o.";
      message += "\n\n";
      if ($scope.model.name) {
        message += "<b>Ime i prezime:</b> " + $scope.model.name + "\n";
      }
      if ($scope.model.email) {
        message += "<b>E-mail adresa:</b> " + $scope.model.email + "\n";
      }
      if ($scope.model.phone) {
        message += "<b>Mobitel ili telefon:</b> " + $scope.model.phone + "\n";
      }
      message += "<b>Poruka:</b>\n" + $scope.model.message;

      var data = {
        'RECAPTCHA_RESPONSE': $scope.gRecaptchaResponse,
        'NAME': $scope.model.name,
        'EMAIL': $scope.model.email,
        'MESSAGE': message
      };
      MailerService.send(data, function (response) {
        console.error(response);
        $scope.isSentInProgress = false;
        if (response && response.data && response.data.success) {
          $scope.isSentSuccess = true;
        } else {
          $scope.isSentError = true;
        }
      }, function (response) {
        console.error(response);
        $scope.isSentInProgress = false;
        $scope.isSentError = true;
      });

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('zelincek')
    .controller('CleaningController', CleaningController);

  /** @ngInject */
  function CleaningController($scope) {
    var vm = this;
    $scope.currentPage = 'cleaning';
  }
})();

(function() {
  'use strict';

  angular
    .module('zelincek')
    .controller('ActionsController', ActionsController);

  /** @ngInject */
  function ActionsController($scope) {
    var vm = this;
    $scope.currentPage = 'actions';
  }
})();

(function() {
  'use strict';

  angular
    .module('zelincek')
    .controller('BarriersController', BarriersController);

  /** @ngInject */
  function BarriersController($scope) {
    var vm = this;

    $scope.fullWidth = true;

    $scope.currentPage = 'barriers';
        $scope.images = [
          {id: 1},
          {id: 2},
          {id: 3},
          {id: 4},
          {id: 5},
          {id: 6},
          {id: 7},
          {id: 8},
          {id: 9},
          {id: 10},
          {id: 11}
        ];

        $scope.currentImage = $scope.images[0];

        $scope.ChangeImage = function (image) {
          $scope.currentImage = image;
        }
      }
    })();

(function() {
  'use strict';

  angular
    .module('zelincek')
    .controller('AboutController', AboutController);

  /** @ngInject */
  function AboutController($scope) {
    var vm = this;
    $scope.currentPage = 'about';

    $scope.smallLogo = true;
  }
})();

(function() {
  'use strict';

  angular
    .module('zelincek')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {
    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('zelincek')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      // .state('home', {
      //   url: '/',
      //   templateUrl: 'app/home/home.html',
      //   controller: 'HomeController',
      //   controllerAs: 'home'
      // })
      .state('cleaningHome', {
        url: '/',
        templateUrl: 'app/cleaning/cleaning.html',
        controller: 'CleaningController',
        controllerAs: 'Cleaning'
      })
      .state('cleaning', {
        url: '/ekoloska-kemijska-cistionica',
        templateUrl: 'app/cleaning/cleaning.html',
        controller: 'CleaningController',
        controllerAs: 'Cleaning'
      })
      .state('cleaningServices', {
        url: '/ekoloska-kemijska-cistionica/usluge',
        templateUrl: 'app/cleaning/services/services.html',
        controller: 'CleaningServicesController',
        controllerAs: 'CleaningServices'
      })
      .state('cleaningPrices', {
        url: '/ekoloska-kemijska-cistionica/cjenik',
        templateUrl: 'app/cleaning/prices/prices.html',
        controller: 'CleaningPricesController',
        controllerAs: 'CleaningPrices'
      })
      .state('cleaningPricesChosen', {
        url: '/ekoloska-kemijska-cistionica/cjenik/:serviceName',
        templateUrl: 'app/cleaning/prices/prices.html',
        controller: 'CleaningPricesController',
        controllerAs: 'CleaningPrices'
      })
      .state('cleaningOrder', {
        url: '/ekoloska-kemijska-cistionica/online-narudzba',
        templateUrl: 'app/cleaning/order/order.html',
        controller: 'CleaningOrderController',
        controllerAs: 'CleaningOrder'
      })
      .state('cleaningServicesChosen', {
        url: '/ekoloska-kemijska-cistionica/usluge/:serviceName',
        templateUrl: 'app/cleaning/services/services.html',
        controller: 'CleaningServicesController',
        controllerAs: 'CleaningServices'
      })
      .state('suits', {
        url: '/rabljena-zastitna-odijela',
        templateUrl: 'app/suits/suits.html',
        controller: 'SuitsController',
        controllerAs: 'suits'
      })
      .state('barriers', {
        url: '/protupoplavne-pregrade',
        templateUrl: 'app/barriers/barriers.html',
        controller: 'BarriersController',
        controllerAs: 'barriers'
      })
      .state('about', {
        url: '/o-nama',
        templateUrl: 'app/about/about.html',
        controller: 'AboutController',
        controllerAs: 'about'
      })
      .state('actions', {
        url: '/akcije',
        templateUrl: 'app/actions/actions.html',
        controller: 'ActionsController',
        controllerAs: 'actions'
      })
      .state('contact', {
        url: '/kontakt',
        templateUrl: 'app/contact/contact.html',
        controller: 'ContactController',
        controllerAs: 'contact'
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('zelincek')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('zelincek')
    .config(config)
    .config(configNoCAPTCHA);

  /** @ngInject */
  function config($logProvider, $locationProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    $locationProvider.hashPrefix('!');
    $locationProvider.html5Mode(true);

  }

  function configNoCAPTCHA (noCAPTCHAProvider) {
    noCAPTCHAProvider.setSiteKey('6LeR1RETAAAAAC2JVCK0qnHEOtm1oIgLLnr_Rlq9');
    noCAPTCHAProvider.setTheme('light');
    noCAPTCHAProvider.setLanguage('hr');
  }


})();

angular.module("zelincek").run(["$templateCache", function($templateCache) {$templateCache.put("app/about/about.html","<div id=\"main\"><div ng-include=\"\'app/common/header/header.html\'\"></div><div class=\"container-fluid body about\"><div class=\"container\"><p>Tvrtka „Zelinček“ je jednostavno društvo s ograničenom odgovornošću. Osnovano je 21. kolovoza 2014. godine sa sjedištem u Ulici Vladimira Nazora 29 u Svetom Ivanu Zelini.</p><p>Primarna djelatnost tvrtke „Zelinček“ je bila prodaja rabljenih zaštitnih odijela. Rabljena zaštitna odijela sastoje se od jakne i hlača i uglavnom se služe u vatrogasne svrhe. Sva odijela su cerftificirana prema europskim normama. Uglavnom posluje s Dobrovoljnim vatrogasnim društvima iz cijele Hrvatske.</p><p>U želji da proširi ponudu tvrtka je uvela i prodaju protupoplavnih pregrada za zaštitu od poplava. Pregrade su namjenjene tvrtkama, gradovima, općinama, ali i običnim ljudima u želji da se spriječe poplave.</p><p>U lipnju 2015. tvrtka „Zelinček“ otvara na istoj adresi u Svetom Ivanu Zelini poslovnicu broj 2 u kojoj je otvoren„Ekološka kemijska čistiona Zelinček“.. Prije samog otvaranja poslovnicu je bilo potrebno u potpunosti renovirati te opremiti namještajem. Ekološka kemijska čistiona otvorena je u suradnji s dvijema velikim tvrtkama koje za tvrku „Zelinček“ vrše uslugu pranja i čišćenja.</p><p>Premda mlada, Tvrtka „Zelinček“ ima u skoroj budućnosti u planu širenje djelatnosti. Cilj nam je pružiti našim korisnicima osim kemijskog pranja odjeće i opreme i uslugu običnog pranja i peglanja. Budući da smo upoznati sa situacijom da danas ljudi imaju sve manje vremena za kućanske poslove odlučili smo pružiti uslugu kućanskog posla koji oduzima dragocijeno vrijeme. Da bi tu uslugu mogli ostvariti potrebno je dodatno ulaganje u tvrtku „Zelinček“ kupnjom perilica i sušilica kao i ostale potrebna opreme za vršenje tih usluga.</p></div></div><div ng-include=\"\'app/common/footer/footer.html\'\"></div></div>");
$templateCache.put("app/actions/actions.html","<div id=\"main\"><div ng-include=\"\'app/common/header/header.html\'\"></div><div class=\"container-fluid body\"><div class=\"container\">Ovo je stranica s akcijama</div></div><div ng-include=\"\'app/common/footer/footer.html\'\"></div></div>");
$templateCache.put("app/barriers/barriers.html","<div id=\"main\"><div ng-include=\"\'app/common/header/header.html\'\"></div><div class=\"container-fluid body suits\"><div class=\"container\"><div class=\"row gallery\"><div class=\"col-xs-12 col-sm-4\"><img ng-src=\"assets/images/barriers-gallery/1.jpg\" class=\"img-responsive main-image\"></div><div class=\"col-xs-12 col-sm-8\"><img ng-src=\"assets/images/barriers-gallery/11.jpg\" class=\"img-responsive main-image\"></div></div></div></div><div ng-include=\"\'app/common/footer/footer.html\'\"></div></div>");
$templateCache.put("app/cleaning/cleaning.html","<div id=\"main\"><div ng-include=\"\'app/common/header/header.html\'\"></div><div class=\"container-fluid body cleaning\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12\"><img ng-src=\"http://akcije.zelincek.hr/uploads/akcija.jpg\" class=\"img-responsive main-image\"></div></div></div></div><div ng-include=\"\'app/common/footer/footer.html\'\"></div></div>");
$templateCache.put("app/contact/contact.html","<div id=\"main\"><div ng-include=\"\'app/common/header/header.html\'\"></div><div class=\"container-fluid body contact\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6\"><h2>Kontaktirajte nas</h2><div class=\"well well-sm\"><h3 ng-show=\"isSentSuccess\">Vaša poruka je poslana, javiti ćemo Vam se u najkraćem mogućem roku, ugodan dan želi Vam Zelinček!</h3><h3 ng-show=\"isSentError\">Vaša poruka je NIJE poslana, jer se dogodila greška, ispričavamo Vam se i molim Vas da pokušate ponovno.</h3><h3 ng-show=\"isSentInProgress\">Molimo Vas, pričekajte nekoliko sekundi, slanje poruke je u tijeku...</h3><form id=\"contact-form\" ng-submit=\"Send()\" ng-hide=\"isSentSuccess || isSentInProgress\"><label class=\"control-label\" for=\"feedback-name\">Ime i prezime</label> <input type=\"text\" id=\"feedback-name\" class=\"form-control\" ng-model=\"model.name\" style=\"\"><div class=\"help-block\"></div><div class=\"form-group field-feedback-email required\"><label class=\"control-label\" for=\"feedback-email\">E-mail</label> <input type=\"email\" id=\"feedback-email\" class=\"form-control\" ng-model=\"model.email\"><div class=\"help-block\"></div></div><div class=\"form-group field-feedback-phone\"><label class=\"control-label\" for=\"feedback-phone\">Mobitel ili telefon</label> <input type=\"text\" id=\"feedback-phone\" class=\"form-control\" ng-model=\"model.phone\"><div class=\"help-block\"></div></div><div class=\"form-group field-feedback-text required\"><label class=\"control-label\" for=\"feedback-text\">Poruka</label> <textarea id=\"feedback-text\" class=\"form-control\" rows=\"6\" ng-model=\"model.message\"></textarea><div class=\"help-block\"></div></div><div class=\"form-group field-feedback-text required\"><label class=\"control-label\" for=\"feedback-text\">Kliknite u kvadratić</label><no-captcha expired-callback=\"expiredCallback\" g-recaptcha-response=\"gRecaptchaResponse\" theme=\"light\" lang=\"hr\" control=\"noCaptchaControl\"></no-captcha></div><button type=\"submit\" class=\"btn btn-default cn-btn\" ng-disabled=\"gRecaptchaResponse === \'\' || expired === true\">Pošaljite poruku</button></form></div></div><div class=\"cos-xs-12 col-sm-6\" style=\"padding-top:50px;font-size:15px\"><h2>Opći podaci</h2><div><h3>ZELINČEK j.d.o.o.</h3><address>Vladimira Nazora 29, 10380 Sveti Ivan Zelina</address><p>Žiro račun - IBAN: HR3223400091110674873 PBZ</p><p>OIB: 95004266444</p><p>Telefon: 01/2061-833</p><p>Mobitel: 099/8020-117</p><p>Email: <a href=\"mailto:info@zelincek.hr\">info@zelincek.hr</a></p></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><h2>Gdje smo?</h2><div><ui-gmap-google-map options=\"{ scrollwheel: false }\" center=\"map.center\" zoom=\"map.zoom\"><ui-gmap-marker coords=\"marker.coords\" options=\"marker.options\" events=\"marker.events\" idkey=\"marker.id\"></ui-gmap-marker></ui-gmap-google-map></div></div></div></div></div><div ng-include=\"\'app/common/footer/footer.html\'\"></div></div>");
$templateCache.put("app/home/home.html","<div id=\"main\"><div ng-include=\"\'app/common/header/header.html\'\"></div><div class=\"container-fluid body home\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4\"><div class=\"circle cistionica\"><a href=\"/ekoloska-kemijska-cistionica\"><img src=\"assets/images/cleaning-homepage.jpg\" class=\"img-circle\" ng-show=\"!isCleaningActive\" ng-mouseenter=\"isCleaningActive=true\"><div class=\"description-text img-circle\" ng-show=\"isCleaningActive\" ng-mouseleave=\"isCleaningActive=false\"><img src=\"assets/images/cleaning-homepage.jpg\" class=\"img-circle\"> <span>Ekološka kemijska čistionica</span></div></a></div></div><div class=\"col-xs-12 col-sm-4\"><div class=\"circle odijelo\"><a href=\"/rabljena-zastitna-odijela\"><img src=\"assets/images/suits-homepage.jpg\" class=\"img-circle\" ng-show=\"!isSuitsActive\" ng-mouseenter=\"isSuitsActive=true\"><div class=\"description-text img-circle\" ng-show=\"isSuitsActive\" ng-mouseleave=\"isSuitsActive=false\"><img src=\"assets/images/suits-homepage.jpg\" class=\"img-circle\"> <span>Rabljena zaštitna odijela</span></div></a></div></div><div class=\"col-xs-12 col-sm-4\"><div class=\"circle pregrada\"><a href=\"/protupoplavne-pregrade\"><img src=\"assets/images/barriers-homepage.jpg\" class=\"img-circle\" ng-show=\"!isBarriersActive\" ng-mouseenter=\"isBarriersActive=true\"><div class=\"description-text img-circle\" ng-show=\"isBarriersActive\" ng-mouseleave=\"isBarriersActive=false\"><img src=\"assets/images/barriers-homepage.jpg\" class=\"img-circle\"> <span>Protupoplavne pregrade</span></div></a></div></div></div></div></div><div ng-include=\"\'app/common/footer/footer.html\'\"></div></div>");
$templateCache.put("app/main/main.html","<div class=\"container\"><div><acme-navbar creation-date=\"main.creationDate\"></acme-navbar></div><div class=\"jumbotron text-center\"><h1>\'Allo, \'Allo!</h1><p class=\"lead\"><img src=\"assets/images/yeoman.png\" alt=\"I\'m Yeoman\"><br>Always a pleasure scaffolding your apps.</p><p class=\"animated infinite\" ng-class=\"main.classAnimation\"><button type=\"button\" class=\"btn btn-lg btn-success\" ng-click=\"main.showToastr()\">Splendid Toastr</button></p><p>With ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'Yeoman\', \'Gulp\', \'Angular\']\"></acme-malarkey></p></div><div class=\"row\"><div class=\"col-sm-6 col-md-4\" ng-repeat=\"awesomeThing in main.awesomeThings | orderBy:\'rank\'\"><div class=\"thumbnail\"><img class=\"pull-right\" ng-src=\"assets/images/{{ awesomeThing.logo }}\" alt=\"{{ awesomeThing.title }}\"><div class=\"caption\"><h3>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p><p><a ng-href=\"{{awesomeThing.url}}\">{{ awesomeThing.url }}</a></p></div></div></div></div></div>");
$templateCache.put("app/suits/suits.html","<div id=\"main\"><div ng-include=\"\'app/common/header/header.html\'\"></div><div class=\"container-fluid body suits\"><div class=\"container\"><div class=\"row gallery\"><div class=\"col-xs-12 col-sm-4\"><img src=\"assets/images/suits-main-image.jpg\" class=\"main-image\"></div><div class=\"col-xs-12 col-sm-8\"><h2 style=\"margin-top: 0px; margin-bottom: 20px\">Za sve dodatne informacije i cijene kontaktirajte nas!</h2><ng-gallery images=\"suits.images\" thumbs-num=\"11\"></ng-gallery></div></div></div></div><div ng-include=\"\'app/common/footer/footer.html\'\"></div></div>");
$templateCache.put("app/cleaning/order/order.html","<div id=\"main\"><div ng-include=\"\'app/common/header/header.html\'\"></div><div class=\"container-fluid body cleaning order\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 description\"><div class=\"well\"><div><span style=\"color:red\"><strong>BESPLATNA DOSTAVA</strong></span> na vašu kućnu adresu!</div><div>Nemate vremena doći do nas, a potrebno Vam je pranje, peglanje ili kemijsko čišćenje?</div><div>Mi dolazimo do VAS!</div></div><div><img src=\"assets/images/kombi.jpg\"></div></div><div class=\"col-xs-12 col-sm-6 order-form\"><h3 ng-show=\"isSentSuccess\">Vaša narudžba je izvršena, javiti ćemo Vam se u najkraćem mogućem roku, ugodan dan želi Vam Zelinček!</h3><h3 ng-show=\"isSentError\">Vaša narudžba NIJE izvršena, jer se dogodila greška, ispričavamo Vam se i molim Vas da pokušate ponovno.</h3><h3 ng-show=\"isSentInProgress\">Molimo Vas pričekajte nekoliko sekundi, slanje narudžbe je u tijeku...</h3><form class=\"well\" ng-submit=\"Order()\" ng-hide=\"isSentSuccess || isSentInProgress\"><h3>Naručite naše usluge online i <strong>ostvarite besplatni</strong> odvoz i dovoz!</h3><div style=\"font-size: 18px\"><label>Tražene usluge:</label></div><div ng-repeat=\"item in services\"><label><input type=\"checkbox\" name=\"selectedServices[]\" value=\"{{item}}\" ng-checked=\"selection.indexOf(item) > -1\" ng-click=\"toggleSelection(item)\"> {{item}}</label></div><br><label class=\"control-label\" for=\"order-name\">Ime i prezime</label> <input type=\"text\" id=\"order-name\" class=\"form-control\" ng-model=\"model.name\" style=\"\"> <label class=\"control-label\" for=\"order-address\">Ulica i broj</label> <input type=\"text\" id=\"order-address\" class=\"form-control\" ng-model=\"model.address\" style=\"\"> <label class=\"control-label\" for=\"order-phone\">Kontakt telefon</label> <input type=\"text\" id=\"order-phone\" class=\"form-control\" ng-model=\"model.phone\" style=\"\"> <label class=\"control-label\" for=\"order-email\">E-mail adresa:</label> <input type=\"text\" id=\"order-email\" class=\"form-control\" ng-model=\"model.email\" style=\"\"> <label class=\"control-label\" for=\"order-pickup\">Termin preuzimanja robe</label> <input type=\"text\" id=\"order-pickup\" class=\"form-control\" ng-model=\"model.pickup\" style=\"\"> <label class=\"control-label\" for=\"order-comment\">Komentar</label> <input type=\"text\" id=\"order-comment\" class=\"form-control\" ng-model=\"model.comment\" style=\"\"><div class=\"form-group required\"><label class=\"control-label\" for=\"order-captcha\">Kliknite u kvadratić</label><no-captcha expired-callback=\"expiredCallback\" g-recaptcha-response=\"gRecaptchaResponse\" theme=\"light\" lang=\"hr\" control=\"noCaptchaControl\"></no-captcha></div><button type=\"submit\" class=\"btn btn-default cn-btn\" ng-disabled=\"gRecaptchaResponse === \'\' || expired === true || selection.length < 1\">Pošaljite narudžbu</button><br><br><div class=\"small\">Uslugu naručivanja putem interneta izvršite najmanje 12 sati prije preuzimanja robe.</div></form></div></div></div></div><div ng-include=\"\'app/common/footer/footer.html\'\"></div></div>");
$templateCache.put("app/cleaning/services/services.html","<div id=\"main\"><div ng-include=\"\'app/common/header/header.html\'\"></div><div class=\"container-fluid body cleaning services\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-3 subpage-links\"><div ng-repeat=\"subpage in subpages\"><a class=\"nounderline\"><button type=\"button\" class=\"btn btn-default btn-block\">{{subpage.title}}</button></a></div></div><div class=\"col-xs-12 col-sm-9\" style=\"font-size:16px;text-align:center\"><div ng-show=\"currentSubpage === \'services\'\"><p>Imate ovakav problem u svom kućanstvu?</p><div><img src=\"assets/images/iron-problem.jpg\"></div><p>Javite nam se, jer mi za Vas imamo rješenje!</p><p style=\"color:red;font-weight:bold\">Peglanje veša za samo 15,00 kn po kilogramu!! :)</p></div><div ng-show=\"currentSubpage === \'ciscenje-odjevnih-predmeta\'\"><div><div class=\"table-responsive\"><div><table class=\"table-striped\"><thead><tr><th class=\"tablehead table-striped\" colspan=\"2\">Čišćenje odjevnih predmeta</th></tr></thead><tbody><tr class=\"success\"><td style=\"font-size:16px\"><strong>Naziv robe - usluge</strong></td><td style=\"font-size:16px\"><strong>Cijena</strong></td></tr><tr><td>Baloner</td><td>85.00 kn</td></tr><tr><td>Bluza</td><td>30.00 kn</td></tr><tr><td>Bluza od svile</td><td>40.00 kn</td></tr><tr><td>Bolero dugi rukav</td><td>35.00 kn</td></tr><tr><td>Bolero kratki rukav</td><td>25.00 kn</td></tr><tr><td>Haljina</td><td>60.00 kn</td></tr><tr><td>Haljina dječja</td><td>30.00 kn</td></tr><tr><td>Haljina svečana (večernja)</td><td>150.00 kn</td></tr><tr><td>Haljina svečana dječja</td><td>50.00 kn</td></tr><tr><td>Haljina svečana kratka</td><td>85.00 kn</td></tr><tr><td>Haljina svilena</td><td>70.00 kn</td></tr><tr><td>Haljina za krštenje</td><td>55.00 kn</td></tr><tr><td>Hlače</td><td>40.00 kn</td></tr><tr><td>Hlače kratke</td><td>30.00 kn</td></tr><tr><td>Jakna- deblja</td><td>70.00 kn</td></tr><tr><td>Jakna- pernata</td><td>85.00 kn</td></tr><tr><td>Jakna- tanka</td><td>50.00 kn</td></tr><tr><td>Jakna dječja</td><td>45.00 kn</td></tr><tr><td>Jakna dječja- pernata</td><td>50.00 kn</td></tr><tr><td>Kapa- šešir</td><td>25.00 kn</td></tr><tr><td>Kaput</td><td>85.00 kn</td></tr><tr><td>Kaput dječji</td><td>35.00 kn</td></tr><tr><td>Kombinezon skijaški dječji</td><td>50.00 kn</td></tr><tr><td>Korzet- topić</td><td>35.00 kn</td></tr><tr><td>Kostim</td><td>85.00 kn</td></tr><tr><td>Kostim ljetni</td><td>75.00 kn</td></tr><tr><td>Košulja</td><td>10.00 kn</td></tr><tr><td>Košulja svilena</td><td>40.00 kn</td></tr><tr><td>Kravata</td><td>15.00 kn</td></tr><tr><td>Majica</td><td>15.00 kn</td></tr><tr><td>Majica- osjetljiva</td><td>25.00 kn</td></tr><tr><td>Majica- dugi rukav</td><td>25.00 kn</td></tr><tr><td>Marama</td><td>15.00 kn</td></tr><tr><td>Odijelo</td><td>80.00 kn</td></tr><tr><td>Odijelo dječje</td><td>55.00 kn</td></tr><tr><td>Prsluk</td><td>25.00 kn</td></tr><tr><td>Prsluk- pernati</td><td>55.00 kn</td></tr><tr><td>Prsluk- zimski</td><td>35.00 kn</td></tr><tr><td>Pulover</td><td>40.00 kn</td></tr><tr><td>Rukavice</td><td>20.00 kn</td></tr><tr><td>Sako</td><td>45.00 kn</td></tr><tr><td>Sako- lagani</td><td>40.00 kn</td></tr><tr><td>Ski hlače</td><td>60.00 kn</td></tr><tr><td>Suknja</td><td>50.00 kn</td></tr><tr><td>Suknja duga</td><td>50.00 kn</td></tr><tr><td>Suknja duga- svečana</td><td>55.00 kn</td></tr><tr><td>Šal</td><td>15.00 kn</td></tr><tr><td>Šal- pašmina</td><td>25.00 kn</td></tr><tr><td>Trenirka</td><td>40.00 kn</td></tr><tr><td>Trenirka u dijelovima</td><td>20.00 kn</td></tr><tr><td>Tunika</td><td>40.00 kn</td></tr><tr><td>Vesta</td><td>45.00 kn</td></tr><tr><td>Vjenčanica</td><td>350.00 kn</td></tr></tbody></table></div></div></div><div class=\"pdv\"></div></div><div ng-show=\"currentSubpage === \'ciscenje-opreme\'\">Ovo je stranica za ciscenja opreme</div><div ng-show=\"currentSubpage === \'bojanje-odjevnih-predmeta\'\">Ovo je stranica za bojanje odjevnih predmeta</div><div ng-show=\"currentSubpage === \'ciscenje-koznih-predmeta\'\">Ovo je stranica za ciscenja koznih predmeta</div><div ng-show=\"currentSubpage === \'bojanje-koznih-predmeta\'\">Ovo je stranica za bojanje koznih predmeta</div><div ng-show=\"currentSubpage === \'peglanje-odjece\'\">Ovo je stranica za peglanje odjece</div><div ng-show=\"currentSubpage === \'pranje-peglanje-odjece\'\">Ovo je stranica za pranje i peglanje odjece</div></div></div></div></div><div ng-include=\"\'app/common/footer/footer.html\'\"></div></div>");
$templateCache.put("app/cleaning/prices/prices.html","<div id=\"main\"><div ng-include=\"\'app/common/header/header.html\'\"></div><div class=\"container-fluid body cleaning services\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-3 subpage-links\"><div ng-repeat=\"subpage in subpages\"><a href=\"/ekoloska-kemijska-cistionica/cjenik/{{subpage.id}}\" class=\"nounderline\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-class=\"{ \'active\': subpage.active }\">{{subpage.title}}</button></a></div></div><div class=\"col-xs-12 col-sm-6 col-md-9\" style=\"font-size:16px;text-align:center\"><div class=\"\"><div ng-show=\"currentSubpage === \'services\'\"><p>Imate ovakav problem u svom kućanstvu?</p><div><img src=\"assets/images/iron-problem.jpg\"></div><p>Javite nam se, jer mi za Vas imamo rješenje!</p><p style=\"color:red;font-weight:bold\">Peglanje veša za samo 15,00 kn po kilogramu!! :)</p></div><div ng-show=\"currentSubpage === \'ciscenje-odjevnih-predmeta\'\"><div><div class=\"table-responsive\"><table class=\"table-striped pricelist-table\"><thead><tr><th class=\"tablehead table-striped\" colspan=\"2\">Čišćenje odjevnih predmeta</th></tr></thead><tbody><tr class=\"success\"><td style=\"font-size:16px\"><strong>Naziv robe - usluge</strong></td><td style=\"font-size:16px\"><strong>Cijena</strong></td></tr><tr><td>Baloner</td><td>85.00 kn</td></tr><tr><td>Bluza</td><td>30.00 kn</td></tr><tr><td>Bluza od svile</td><td>40.00 kn</td></tr><tr><td>Bolero dugi rukav</td><td>35.00 kn</td></tr><tr><td>Bolero kratki rukav</td><td>25.00 kn</td></tr><tr><td>Haljina</td><td>60.00 kn</td></tr><tr><td>Haljina dječja</td><td>30.00 kn</td></tr><tr><td>Haljina svečana (večernja)</td><td>150.00 kn</td></tr><tr><td>Haljina svečana dječja</td><td>50.00 kn</td></tr><tr><td>Haljina svečana kratka</td><td>85.00 kn</td></tr><tr><td>Haljina svilena</td><td>70.00 kn</td></tr><tr><td>Haljina za krštenje</td><td>55.00 kn</td></tr><tr><td>Hlače</td><td>40.00 kn</td></tr><tr><td>Hlače kratke</td><td>30.00 kn</td></tr><tr><td>Jakna- deblja</td><td>70.00 kn</td></tr><tr><td>Jakna- pernata</td><td>85.00 kn</td></tr><tr><td>Jakna- tanka</td><td>50.00 kn</td></tr><tr><td>Jakna dječja</td><td>45.00 kn</td></tr><tr><td>Jakna dječja- pernata</td><td>50.00 kn</td></tr><tr><td>Kapa- šešir</td><td>25.00 kn</td></tr><tr><td>Kaput</td><td>85.00 kn</td></tr><tr><td>Kaput dječji</td><td>35.00 kn</td></tr><tr><td>Kombinezon skijaški dječji</td><td>50.00 kn</td></tr><tr><td>Korzet- topić</td><td>35.00 kn</td></tr><tr><td>Kostim</td><td>85.00 kn</td></tr><tr><td>Kostim ljetni</td><td>75.00 kn</td></tr><tr><td>Košulja</td><td>10.00 kn</td></tr><tr><td>Košulja svilena</td><td>40.00 kn</td></tr><tr><td>Kravata</td><td>15.00 kn</td></tr><tr><td>Majica</td><td>15.00 kn</td></tr><tr><td>Majica- osjetljiva</td><td>25.00 kn</td></tr><tr><td>Majica- dugi rukav</td><td>25.00 kn</td></tr><tr><td>Marama</td><td>15.00 kn</td></tr><tr><td>Odijelo</td><td>80.00 kn</td></tr><tr><td>Odijelo dječje</td><td>55.00 kn</td></tr><tr><td>Prsluk</td><td>25.00 kn</td></tr><tr><td>Prsluk- pernati</td><td>55.00 kn</td></tr><tr><td>Prsluk- zimski</td><td>35.00 kn</td></tr><tr><td>Pulover</td><td>40.00 kn</td></tr><tr><td>Rukavice</td><td>20.00 kn</td></tr><tr><td>Sako</td><td>45.00 kn</td></tr><tr><td>Sako- lagani</td><td>40.00 kn</td></tr><tr><td>Ski hlače</td><td>60.00 kn</td></tr><tr><td>Suknja</td><td>50.00 kn</td></tr><tr><td>Suknja duga</td><td>50.00 kn</td></tr><tr><td>Suknja duga- svečana</td><td>55.00 kn</td></tr><tr><td>Šal</td><td>15.00 kn</td></tr><tr><td>Šal- pašmina</td><td>25.00 kn</td></tr><tr><td>Trenirka</td><td>40.00 kn</td></tr><tr><td>Trenirka u dijelovima</td><td>20.00 kn</td></tr><tr><td>Tunika</td><td>40.00 kn</td></tr><tr><td>Vesta</td><td>45.00 kn</td></tr><tr><td>Vjenčanica</td><td>350.00 kn</td></tr></tbody></table></div></div></div><div ng-show=\"currentSubpage === \'ciscenje-opreme\'\"><div><div class=\"table-responsive\"><table class=\"table-striped pricelist-table\"><thead><tr><th class=\"tablehead table-striped\" colspan=\"2\">Čišćenje opreme</th></tr></thead><tbody><tr><td><strong>Naziv robe- usluge</strong></td><td><strong>Cijena</strong></td></tr><tr><td>Abažur</td><td>10.00 kn</td></tr><tr><td>Abažur m2</td><td>15.00 kn</td></tr><tr><td>Deka dječja</td><td>40.00 kn</td></tr><tr><td>Deka dvostruka</td><td>70.00 kn</td></tr><tr><td>Deka jednostruka</td><td>50.00 kn</td></tr><tr><td>Deka merino vuna- dvostruka</td><td>130.00 kn</td></tr><tr><td>Deka merino vuna- jednostruka</td><td>90.00 kn</td></tr><tr><td>Jastučnica- merino vuna</td><td>40.00 kn</td></tr><tr><td>Jastučnica mala</td><td>10.00 kn</td></tr><tr><td>Jastučnica velika</td><td>15.00 kn</td></tr><tr><td>Jastuk mali</td><td>20.00 kn</td></tr><tr><td>Jastuk od perja</td><td>70.00 kn</td></tr><tr><td>Jastuk za stolicu</td><td>10.00 kn</td></tr><tr><td>Jastuk za stolicu- veći</td><td>20.00 kn</td></tr><tr><td>Jastuk za stolicu s naslonom</td><td>35.00 kn</td></tr><tr><td>Kombinezon radni</td><td>45.00 kn</td></tr><tr><td>Kuhinjska krpa</td><td>10.00 kn</td></tr><tr><td>Nadstolnjak</td><td>15.00 kn</td></tr><tr><td>Navlaka za dvosjed</td><td>65.00 kn</td></tr><tr><td>Navlaka za madrac</td><td>55.00 kn</td></tr><tr><td>Navlaka za madrac- dvostruki</td><td>75.00 kn</td></tr><tr><td>Navlaka za poplun</td><td>25.00 kn</td></tr><tr><td>Navlaka za poplun- dvostruki</td><td>30.00 kn</td></tr><tr><td>Navlaka za stolicu bez naslona</td><td>20.00 kn</td></tr><tr><td>Navlaka za stolicu s naslonom</td><td>25.00 kn</td></tr><tr><td>Navlaka za tabure</td><td>40.00 kn</td></tr><tr><td>Navlaka za trosjed</td><td>75.00 kn</td></tr><tr><td>Plahta dvostruka</td><td>20.00 kn</td></tr><tr><td>Plahta obična</td><td>15.00 kn</td></tr><tr><td>Plišana igračka- do 50 cm</td><td>25.00 kn</td></tr><tr><td>Plišana igračka- do 80 cm</td><td>45.00 kn</td></tr><tr><td>Plišana igračka- iznad 80 cm</td><td>65.00 kn</td></tr><tr><td>Poplun dupli</td><td>110.00 kn</td></tr><tr><td>Prekrivač za krevet</td><td>45.00 kn</td></tr><tr><td>Prekrivač za krevet- dvostruki</td><td>70.00 kn</td></tr><tr><td>Presvlaka za fotelju</td><td>50.00 kn</td></tr><tr><td>Radna bluza</td><td>25.00 kn</td></tr><tr><td>Radna suknja</td><td>25.00 kn</td></tr><tr><td>Radne hlače</td><td>30.00 kn</td></tr><tr><td>Ručnik mali</td><td>5.00 kn</td></tr><tr><td>Ručnik srednji</td><td>8.00 kn</td></tr><tr><td>Ručnik veliki</td><td>10.00 kn</td></tr><tr><td>Salveta</td><td>10.00 kn</td></tr><tr><td>Stolnjak (4-6 osoba)</td><td>15.00 kn</td></tr><tr><td>Stolnjak (8-12 osoba)</td><td>20.00 kn</td></tr><tr><td>Stolnjak (banket)</td><td>35.00 kn</td></tr><tr><td>Stolnjak k.ć.- m2</td><td>20.00 kn</td></tr><tr><td>Štep deka</td><td>75.00 kn</td></tr><tr><td>Štep deka dvostruka</td><td>90.00 kn</td></tr><tr><td>Tepih- m2</td><td>40.00 kn</td></tr><tr><td>Vreća za spavanje</td><td>100.00 kn</td></tr><tr><td>Zavjesa (platno)</td><td>20.00 kn</td></tr><tr><td>Zavjesa (pliš)</td><td>30.00 kn</td></tr><tr><td>Zavjesa (sintetika)</td><td>15.00 kn</td></tr><tr><td>Zavjesa k.č.- m2</td><td>30.00 kn</td></tr></tbody></table></div></div></div><div ng-show=\"currentSubpage === \'bojanje-odjevnih-predmeta\'\"><div><div class=\"table-responsive\"><table class=\"table-striped pricelist-table\"><thead><tr><th class=\"tablehead table-striped\" colspan=\"2\">Bojanje odjevnih predmeta</th></tr></thead><tbody><tr><td><strong>Naziv robe- usluge</strong></td><td><strong>Cijena</strong></td></tr><tr><td>Bojanje jakne tanje duže</td><td>65.00 kn</td></tr><tr><td>Bojanje balonera dužeg</td><td>85.00 kn</td></tr><tr><td>Bojanje balonera kraćeg</td><td>75.00 kn</td></tr><tr><td>Bojanje bermuda</td><td>35.00 kn</td></tr><tr><td>Bojanje haljine duge</td><td>60.00 kn</td></tr><tr><td>Bojanje haljine kratke</td><td>50.00 kn</td></tr><tr><td>Bojanje hlača</td><td>45.00 kn</td></tr><tr><td>Bojanje hlača kratkih</td><td>35.00 kn</td></tr><tr><td>Bojanje hlača treger</td><td>50.00 kn</td></tr><tr><td>Bojanje jakne deblje duže</td><td>75.00 kn</td></tr><tr><td>Bojanje jakne deblje kraće</td><td>65.00 kn</td></tr><tr><td>Bojanje jakne tanje kraće</td><td>55.00 kn</td></tr><tr><td>Bojanje kombinezona debljeg</td><td>75.00 kn</td></tr><tr><td>Bojanje kombinezona tanjeg</td><td>70.00 kn</td></tr><tr><td>Bojanje košulje dugih rukava</td><td>45.00 kn</td></tr><tr><td>Bojanje košulje kratkih rukava</td><td>35.00 kn</td></tr><tr><td>Bojanje majice dugih rukava</td><td>35.00 kn</td></tr><tr><td>Bojanje majice kratkih rukava</td><td>30.00 kn</td></tr><tr><td>Bojanje navlake za stolicu</td><td>35.00 kn</td></tr><tr><td>Bojanje prsluka debljeg</td><td>45.00 kn</td></tr><tr><td>Bojanje prsluka tanjeg</td><td>40.00 kn</td></tr><tr><td>Bojanje rukavica</td><td>30.00 kn</td></tr><tr><td>Bojanje sakoa</td><td>55.00 kn</td></tr><tr><td>Bojanje stolnjaka</td><td>40.00 kn</td></tr><tr><td>Bojanje suknje</td><td>45.00 kn</td></tr><tr><td>Bojanje suknje duge</td><td>50.00 kn</td></tr><tr><td>Bojanje šala</td><td>20.00 kn</td></tr><tr><td>Bojanje veste deblje</td><td>50.00 kn</td></tr><tr><td>Bojanje veste tanje</td><td>45.00 kn</td></tr></tbody></table></div></div></div><div ng-show=\"currentSubpage === \'ciscenje-koznih-predmeta\'\"><div><div class=\"table-responsive\"><table class=\"table-striped pricelist-table\"><thead><tr><th class=\"tablehead table-striped\" colspan=\"2\">Čišćenje kožnih predmeta</th></tr></thead><tbody><tr><td><strong>Naziv robe- usluge</strong></td><td><strong>Cijena</strong></td></tr><tr><td>Kožna jakna duga</td><td>220.00 kn</td></tr><tr><td>Kožna jakna kratka</td><td>180.00 kn</td></tr><tr><td>Kožna torba</td><td>150.00 kn</td></tr><tr><td>Kožne čizme</td><td>150.00 kn</td></tr><tr><td>Kožne hlače</td><td>120.00 kn</td></tr></tbody></table></div></div></div><div ng-show=\"currentSubpage === \'bojanje-koznih-predmeta\'\">Ovo je stranica za bojanje koznih predmeta</div><div ng-show=\"currentSubpage === \'peglanje-odjece\'\"><div><div class=\"table-responsive\"><table class=\"table-striped pricelist-table\"><thead><tr><th class=\"tablehead table-striped\" colspan=\"2\">Peglanje odjeće</th></tr></thead><tbody><tr><td><strong>Naziv robe- usluge</strong></td><td><strong>Cijena</strong></td></tr><tr><td>Dječja robica- 1kg</td><td>16.00 kn</td></tr><tr><td>Donje rublje</td><td>2.00 kn</td></tr><tr><td>Duge gaće</td><td>4.00 kn</td></tr><tr><td>Haljina pamučna</td><td>8.00 kn</td></tr><tr><td>Hlače duge</td><td>12.00 kn</td></tr><tr><td>Hlače kratke</td><td>9.00 kn</td></tr><tr><td>Jastučnica mala</td><td>4.00 kn</td></tr><tr><td>Jastučnica velika</td><td>6.00 kn</td></tr><tr><td>Krpa kuhinjska</td><td>3.00 kn</td></tr><tr><td>Majica s kapuljačom</td><td>9.00 kn</td></tr><tr><td>Majica dugi rukav</td><td>8.00 kn</td></tr><tr><td>Majica kratki rukav</td><td>7.00 kn</td></tr><tr><td>Navlaka za poplun</td><td>15.00 kn</td></tr><tr><td>Navlaka za poplun dupla</td><td>16.00 kn</td></tr><tr><td>Ogrtač</td><td>12.00 kn</td></tr><tr><td>Peglanje veša</td><td>15.00 kn</td></tr><tr><td>Pidžama</td><td>9.00 kn</td></tr><tr><td>Plahta</td><td>7.00 kn</td></tr><tr><td>Plahta dupla</td><td>13.00 kn</td></tr><tr><td>Potkošulja</td><td>3.00 kn</td></tr><tr><td>Pulover/vesta</td><td>10.00 kn</td></tr><tr><td>Ručnik mali</td><td>2.00 kn</td></tr><tr><td>Ručnik srednji</td><td>3.00 kn</td></tr><tr><td>Ručnik veliki</td><td>4.00 kn</td></tr><tr><td>Spavačica</td><td>9.00 kn</td></tr><tr><td>Stolnjak mali (4-6 osoba)</td><td>8.00 kn</td></tr><tr><td>Stolnjak veliki (8-12 osoba)</td><td>10.00 kn</td></tr><tr><td>Suknja</td><td>7.00 kn</td></tr><tr><td>Trenirka</td><td>15.00 kn</td></tr></tbody></table></div></div></div><div ng-show=\"currentSubpage === \'pranje-peglanje-odjece\'\"><div><div class=\"table-responsive\"><table class=\"table-striped pricelist-table\"><thead><tr><th class=\"tablehead table-striped\" colspan=\"2\">Pranje i peglanje odjevnih predmeta</th></tr></thead><tbody><tr><td><strong>Naziv robe- usluge</strong></td><td><strong>Cijena</strong></td></tr><tr><td>Dječja robica- 1kg</td><td>20.00 kn</td></tr><tr><td>Donje rublje</td><td>3.00 kn</td></tr><tr><td>Duge gaće</td><td>6.00 kn</td></tr><tr><td>Haljina pamučna</td><td>10.00 kn</td></tr><tr><td>Hlače duge</td><td>15.00 kn</td></tr><tr><td>Hlače kratke</td><td>11.00 kn</td></tr><tr><td>Jastučnica mala</td><td>6.00 kn</td></tr><tr><td>Jastučnica velika</td><td>8.00 kn</td></tr><tr><td>Majica s kapuljačom</td><td>12.00 kn</td></tr><tr><td>Majica dugi rukav</td><td>10.00 kn</td></tr><tr><td>Majica kratki rukav</td><td>9.00 kn</td></tr><tr><td>Navlaka za poplun</td><td>18.00 kn</td></tr><tr><td>Navlaka za poplun dupla</td><td>20.00 kn</td></tr><tr><td>Ogrtač</td><td>16.00 kn</td></tr><tr><td>Peglanje veša</td><td>15.00 kn</td></tr><tr><td>Pidžama</td><td>13.00 kn</td></tr><tr><td>Plahta</td><td>9.00 kn</td></tr><tr><td>Plahta dupla</td><td>16.00 kn</td></tr><tr><td>Potkošulja</td><td>4.00 kn</td></tr><tr><td>Pulover/vesta</td><td>14.00 kn</td></tr><tr><td>Ručnik mali</td><td>3.00 kn</td></tr><tr><td>Ručnik srednji</td><td>5.00 kn</td></tr><tr><td>Ručnik veliki</td><td>7.00 kn</td></tr><tr><td>Spavačica</td><td>13.00 kn</td></tr><tr><td>Stolnjak mali (4-6 osoba)</td><td>10.00 kn</td></tr><tr><td>Stolnjak veliki (8-12 osoba)</td><td>15.00 kn</td></tr><tr><td>Suknja</td><td>9.00 kn</td></tr><tr><td>Trenirka</td><td>17.00 kn</td></tr><tr><td>Pranje 1kg *</td><td>12.00 kn</td></tr><tr><td>Peglanje 1kg *</td><td>15.00 kn</td></tr><tr><td>Pranje i peglanje 1kg *</td><td>20.00 kn</td></tr></tbody></table></div></div><div>Cijena po kilogramu se računa na količine veće od 4 kg.</div></div></div></div></div></div></div><div ng-include=\"\'app/common/footer/footer.html\'\"></div></div>");
$templateCache.put("app/common/footer/footer.html","<div class=\"container-fluid footer\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-8 copyright\"><address>Sva prava pridržana © 2015 - 2016 by <strong>ZELINČEK j.d.o.o.</strong></address></div><div class=\"col-xs-12 col-sm-4 facebook\"><a href=\"https://www.facebook.com/profile.php?id=100009296994861\" target=\"_blank\"><img src=\"assets/images/facebook.png\"></a></div></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 extra-footer\">Skraćeni naziv: ZELINČEK j.d.o.o.; Puni naziv tvrtke: ZELINČEK jednostavno društvo s ograničenom odgovornošću za trgovinu i usluge<br>Sjedište tvrtke: Sveti Ivan Zelina (Grad Sveti Ivan Zelina), Vladimira Nazora 29; Žiro račun - IBAN: HR3223400091110674873 PBZ;<br>OIB: 95004266444; MBS: 080927263 Trgovački sud u Zagrebu;<br>Temeljni kapital: 50,00 kn uplaćen u cijelosti; Odgovorna osoba: Janko Houška</div></div></div>");
$templateCache.put("app/common/header/header.html","<div class=\"container-fluid header\"><div class=\"container\"><div class=\"row\"><div class=\"col-sm-offset-3 col-sm-6\" ng-class=\"{ \'col-md-6\': smallLogo, \'col-sm-offset-3\': !smallLogo, \'col-sm-offset-3\': !smallLogo, \'col-md-6\': !smallLogo }\"><a href=\"/\"><img src=\"assets/images/logo-homepage.png\" class=\"logo\"></a></div><div class=\"col-sm-12 col-md-12 navigation top\" style=\"text-align: center\" ng-show=\"currentPage === \'home\'\"><a href=\"/o-nama\" class=\"nounderline\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-class=\"{ active: currentPage === \'about\'}\">O nama</button></a> <a href=\"/akcije\" class=\"nounderline\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-class=\"{ active: currentPage === \'actions\'}\">Akcije</button></a> <a href=\"/kontakt\" class=\"nounderline\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-class=\"{ active: currentPage === \'contact\'}\">Kontakt</button></a></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-class=\"{ \'col-sm-6\': !fullWidth }\"><div class=\"logo-description\" ng-show=\"currentPage === \'home\'\">Poduzeće kojem vjerujete</div><div class=\"logo-description\" ng-show=\"currentPage === \'cleaning\'\">Ekološka kemijska čistionica</div><div class=\"logo-description\" ng-show=\"currentPage === \'suits\'\">Uvoz i prodaja rabljenih zaštitnih odijela</div><div class=\"logo-description\" ng-show=\"currentPage === \'barriers\'\">Prodaja WP WASTO i PVC pregrada za obranu od poplava</div></div><div class=\"col-xs-12 col-sm-6\" ng-hide=\"fullWidth\"><div class=\"landing-description\" ng-show=\"currentPage === \'cleaning\'\"><a href=\"/ekoloska-kemijska-cistionica/online-narudzba\" class=\"nounderline\"><button type=\"button\" class=\"btn btn-default\">BESPLATNA dostava uz ONLINE narudžbu!</button></a></div></div></div></div></div><div class=\"container-fluid navigation mainmenu\" ng-show=\"currentPage !== \'home\'\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-6 col-sm-3 col-sm-offset-0\"><a href=\"/\" class=\"nounderline\"><button type=\"button\" class=\"btn btn-default btn-block\">Naslovnica</button></a></div><div class=\"col-xs-6 col-sm-2\"><a href=\"/ekoloska-kemijska-cistionica/usluge\" class=\"nounderline\"><button type=\"button\" class=\"btn btn-default btn-block\">Usluge</button></a></div><div class=\"col-xs-6 col-sm-2\"><a href=\"/ekoloska-kemijska-cistionica/cjenik\" class=\"nounderline\"><button type=\"button\" class=\"btn btn-default btn-block\">Cjenik</button></a></div><div class=\"col-xs-6 col-sm-2\"><a href=\"/o-nama\" class=\"nounderline\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-class=\"{ active: currentPage === \'about\'}\">O nama</button></a></div><div class=\"col-xs-6 col-sm-3\"><a href=\"/kontakt\" class=\"nounderline\"><button type=\"button\" class=\"btn btn-default btn-block\" ng-class=\"{ active: currentPage === \'contact\'}\">Kontakt</button></a></div></div></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"https://github.com/Swiip/generator-gulp-angular\"><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");}]);